import I18n from 'I18n';
export const getFlpDisabledPropertyMessage = (name = '') => {
  // There are some HubSpot-defined properties with readonly permissions that
  // cannot be changed. For these, we want to show a different FLP tooltip.
  // https://git.hubteam.com/HubSpot/CrmPermissions/blob/f9b5baa0aa30044e1c45ee925fffd7e72567c224/CrmPermissionsData/src/main/java/com/hubspot/crm/permissions/data/flp/StageCalculatedPropertiesReadOnlyHelper.java#L12
  // https://hubspot.slack.com/archives/C06MVA9PR0U/p1728668765153389
  const isHubSpotDefinedReadonlyProperty = ['hs_v2_date_entered_', 'hs_v2_date_exited_', 'hs_v2_latest_time_in_', 'hs_v2_cumulative_time_in_'].some(prefix => name.startsWith(prefix));
  if (isHubSpotDefinedReadonlyProperty) {
    return I18n.text('getFlpDisabledPropertyMessage.hubspotProvidedProperty');
  }
  return I18n.text('getFlpDisabledPropertyMessage.noAccess');
};